/**
 * Colour classes for the `tone` prop shared by the typography components, so
 * Text and Heading cannot drift apart.
 */
import type { TextTone } from './types';

export const textToneStyles = {
  default: '',
  muted: 'text-muted-foreground',
  subtle: 'text-subtle-foreground',
  critical: 'text-text-critical',
  success: 'text-text-success',
  info: 'text-text-info',
  warning: 'text-text-warning',
} satisfies Record<TextTone, string>;
